import { computeMarginPrice } from "../helpers/computeMarginPrice";
import { QuoteRequestLine } from "../types";
import { adaptComputedCost } from "./adaptComputedCost";
import { computeDesignCost } from "./computeDesignCost";

export function computeGeneralPrice(quoteRequestLine: QuoteRequestLine): {
  partGeneralPrice: number;
  partGeneralCost: number;
  partGeneralMarginPrice: number;
} {
  const { quantity } = quoteRequestLine;

  if (!quantity) {
    return {
      partGeneralPrice: 0,
      partGeneralCost: 0,
      partGeneralMarginPrice: 0,
    };
  }

  const designCost = computeDesignCost({
    designOfficeHourlyRate: quoteRequestLine.designOfficeHourlyRate,
    designOfficeTime: quoteRequestLine.designOfficeTime,
  });

  const computedPartGeneralCost = designCost / quantity;

  const computedPartGeneralMarginPrice = computeMarginPrice({
    cost: computedPartGeneralCost,
    marginRatio: quoteRequestLine.designOfficeMarginRatio || 0,
  });

  const {
    cost: partGeneralCost,
    marginPrice: partGeneralMarginPrice,
    price: partGeneralPrice,
  } = adaptComputedCost({
    cost: computedPartGeneralCost,
    marginPrice: computedPartGeneralMarginPrice,
  });

  return {
    partGeneralPrice,
    partGeneralCost,
    partGeneralMarginPrice,
  };
}
